import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ed7a5312"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex align-center justify-center",
  style: {"width":"80vw","height":"70vh","overflow-y":"scroll"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Etes vous sur de vouloir supprimer cet élément ?", -1))
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  class: "flex",
  style: {"gap":"12px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "back-icon",
  src: "/ico/circle-left.svg"
}, null, -1))
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted center"
}
const _hoisted_11 = {
  key: 1,
  ref: "grid",
  id: "documentGrid",
  class: "grid"
}
const _hoisted_12 = {
  key: 2,
  class: "center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeInputFile = _resolveComponent("SeInputFile")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_DocumentRow = _resolveComponent("DocumentRow")!
  const _component_SeLoadingIndicator = _resolveComponent("SeLoadingIndicator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      title: "Image",
      ref: "imageModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "image",
            src: _ctx.imgUrl
          }, null, 8, _hoisted_2)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      ref: "deletionModal",
      title: "Infos"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SeButton, {
            onPress: _ctx.performDeletion,
            class: "modal-valid w100"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Oui")
            ]),
            _: 1
          }, 8, ["onPress"]),
          _createVNode(_component_SeButton, {
            onPress: _ctx.cancelDeletion,
            class: "w100"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Non")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      title: "Rename",
      ref: "renameModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeInput, {
          style: {"width":"80vw","max-width":"350px"},
          ref: "itemName",
          placeholder: "Name"
        }, null, 512),
        _createVNode(_component_SeButton, {
          onPress: _ctx.applyRename,
          class: "modal-valid",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      title: "Create folder",
      ref: "createFolderModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeInput, {
          style: {"width":"80vw","max-width":"350px"},
          ref: "folderName",
          placeholder: "Name"
        }, null, 512),
        _createVNode(_component_SeButton, {
          onPress: _ctx.createFolder,
          class: "modal-valid",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", {
      class: "panel",
      onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1),
        _createVNode(_component_ReadonlyField, {
          locked: _ctx.path == '/' ||
        (_ctx.path.includes('database') && _ctx.user!.role != _ctx.Role.Manager)
        || (_ctx.path.includes('distributors') && (_ctx.user!.role != _ctx.Role.Distributor && _ctx.user!.role != _ctx.Role.Admin))
        
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_SeInputFile, {
                ref: "upload",
                onChange: _ctx.uploadFile,
                icon: "/ico/upload.svg"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Upload")
                ]),
                _: 1
              }, 8, ["onChange"]),
              _createVNode(_component_SeButton, {
                onPress: _ctx.openCreateFolderModal,
                icon: "/ico/folder-add.svg"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("new-folder")), 1)
                ]),
                _: 1
              }, 8, ["onPress"])
            ])
          ]),
          _: 1
        }, 8, ["locked"])
      ]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
        class: "flex align-center",
        style: {"margin":"12px 0px"}
      }, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.displayPath), 1)
      ]),
      _createVNode(_component_SearchBar, {
        targetGridId: "documentGrid",
        ref: "searchBar"
      }, null, 512),
      (_ctx.cloudItems.length == 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "No files found."))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloudItems, (item) => {
              return (_openBlock(), _createBlock(_component_DocumentRow, {
                "rename-click": _ctx.renameClick,
                "delete-click": _ctx.deleteClick,
                "download-click": _ctx.downloadClick,
                "lock-click": _ctx.lockClick,
                onClick: ($event) => _ctx.itemClick($event, item),
                item: item
              }, null, 8, ["rename-click", "delete-click", "download-click", "lock-click", "onClick", "item"]))
            }), 256))
          ], 512))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_SeLoadingIndicator)
          ]))
    ], 32)
  ], 64))
}